export const phoneNumberRegex = /^\d+$/
export const expDateRegex = /([1][0-2]|[0][1-9]) \/ \d{4}/
export const licencePlateRegex = /^[a-zA-Z0-9\s]+$/
export const countryCodeRegex = /^(\+?\d{1,3}|\d{1,4})$/
export const allowedCodeCharactersRegex = /^[0-9]$/
export const zipCodeRegex = /^[\w\-\s]+$/
